import { factory, getResponseCamelization } from '@repo-level/core-front';
import { buildCmsUrl, getResponseCMS } from './base';
import { isCMSV3 } from 'helpers/conf';

export interface CmsStardustRush {
  startDate: string;
  endDate: string;
  vip1Goal: number;
  vip2Goal: number;
  vip3Goal: number;
  pVipText: string;
  gameCompleteText: string;
}

export const stardustRushV3 = factory((r) => (lang: string) =>
  r<CmsStardustRush>('get', buildCmsUrl({ path: 'stardust-rush', lang }))
);

export const stardustRushV4 = factory((r) => (lang: string) =>
  r<CmsStardustRush>(
    'get',
    buildCmsUrl({ path: 'stardust-rush', lang }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const stardustRush = isCMSV3 ? stardustRushV3 : stardustRushV4;
